<template>
  <body class="forInfluencers-body" id="forInfluencers">
    <div class="text-wrapper">
      <TextLabel labelColor="white" labelText="Partnership Program" />
      <div class="title">For Influencers</div>
      <div class="text">
        Wecobi is revolutionizing the way brands approach unsold inventory,
        sustainability, and profitability, and we’re looking for influencers who
        share our passion for change. The Wecobi Influencer Partner Program is
        your opportunity to collaborate with us in reshaping the retail industry
        while amplifying your voice on sustainability, fashion, beauty, and
        consumer culture.
      </div>
    </div>
    <div class="image-wrapper"></div>
  </body>
</template>

<script>
import TextLabel from "@/components/Sustainability/Content/ReusableComponents/TextLabel.vue";

export default {
  name: "ForInfluensers",
  components: {
    TextLabel,
  },
};
</script>

<style scoped>
.forInfluencers-body {
  width: 100%;
  height: 650px;
  border-radius: 20px;
  display: flex;
  overflow: hidden;
}
.text-wrapper {
  width: 50%;
  height: 100%;
  background: linear-gradient(to left, #000000 0%, #232323 100%);
  padding: 0px 70px 0px 90px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}
.image-wrapper {
  width: 50%;
  height: 100%;
  background-image: url("../../../assets/PartnersProgram/ForInfluencers.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.title {
  font-size: 45px;
  font-weight: 600;
  line-height: 1.2;
  color: #ffffff;
}
.text {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: #ffffff;
}

@media (max-width: 1280px) {
  .title {
    font-size: 40px;
  }
  .text {
    font-size: 14px;
  }
}

@media (max-width: 1024px) {
  .text-wrapper {
    padding: 0px 70px 0px 80px;
    gap: 20px;
  }
  .title {
    font-size: 35px;
  }
}
@media (max-width: 850px) {
  .forInfluencers-body {
    flex-direction: column-reverse;
    height: 726px;
  }
  .text-wrapper {
    padding: 0px 60px;
    gap: 20px;
  }
  .text-wrapper,
  .image-wrapper {
    width: 100%;
    height: 50%;
  }
  .hide {
    display: none;
  }
}
@media (max-width: 588px) {
  .forInfluencers-body {
    height: 599px;
  }
  .text-wrapper {
    padding: 0px 50px;
    gap: 20px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
@media (max-width: 431px) {
  .forInfluencers-body {
    height: 700px;
  }
  .image-wrapper {
    height: 291px;
  }
  .text-wrapper {
    padding: 0px 40px;
    gap: 20px;
    height: 409px;
  }
  .title {
    font-size: 30px;
  }
  .text {
    font-size: 12px;
  }
}
</style>
